export const MODEL_CART_WIDTH = '400px';
